import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';
import DateTime from 'react-datetime';
import * as moment from 'moment';

class PatientForm extends React.Component {
 
  componentWillReceiveProps() {
    const {
      initialValues: { gender, stateId, addressState, employerCodeNumber, employerName, dob },
    } = this.props;

    if (gender !== null) {
      if (gender.toLowerCase() === 'm') {
        const option = { id: 1, name: 'Male' };
        this.props.change('genderObj', option);
      }
      else if (gender.toLowerCase() === 'f') {
        const option = { id: 2, name: 'Female' };
        this.props.change('genderObj', option);
      }
      else {
        const option = { id: 3, name: 'Other' };
        this.props.change('genderObj', option);
      }
    }
    if (stateId !== null) {
      const option = { id: stateId, name: addressState };
      this.props.change('state', option);
    }
    if (employerCodeNumber !== null) {
      const option = { employerCodeNumber: employerCodeNumber, employerCodeDescription: employerName };
      this.props.change('client', option);
    }
    if (dob !== null) {
      const dobformatted = moment(dob).format('MM/DD/YYYY');
      this.props.change('dob', dobformatted);
    }
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    placeholder,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly={readOnly}
                  disabled={disabled}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select id="select" {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onChange = (e, val) => {
    const select = document.getElementById('select');
    this.props.change('stateId', val);
    this.props.change('addressState', select.options[select.selectedIndex].text);
  }

  renderGenderSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchGenders}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Gender..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onGenderChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onGenderChange = (val) => {
    this.props.change('genderObj', val);
  }

  renderEmployersSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchEmployers}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Employer..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onEmployerChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onEmployerChange = (val) => {
    this.props.change('employer', val);
  }

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.employerCodeNumber}
          getOptionLabel={(option) => option.employerCodeDescription}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('client', val);
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderPhoneTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchPhoneTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Phone Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPhoneTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPhoneTypeChange = (val) => {
    this.props.change('phoneType', val);
  }

  renderStatesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchStates}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="State..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onStateChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onStateChange = (val) => {
    this.props.change('state', val);
  }
  
  render() {
    const {
      handleSubmit,
      pristine,
      states,
      initialValues,
      submitting,
    } = this.props;

    initialValues.dob = (initialValues.dob != null) ? moment(initialValues.dob).format('MM/DD/YYYY') : initialValues.dob;
    const states1 = (states != null) ? states.filter(el => el.id > 0) : states;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Patient Information</legend>
          {/*<Field*/}
          {/*  name="employer"*/}
          {/*  component={this.renderEmployersSelect}*/}
          {/*  label="Employer"*/}
          {/*/>*/}
          <Field
            name="client"
            component={this.renderClientsSelect}
            label="Client"
          />
          <legend></legend>
          <Field
            className="form-control"
            name="firstName"
            component={this.renderField}
            type="text"
            placeholder="First Name"
            label="First Name"
          />
          <Field
            className="form-control"
            name="middleName"
            component={this.renderField}
            type="text"
            placeholder="Middle Name"
            label="Middle Name"
          />
          <Field
            className="form-control"
            name="lastName"
            component={this.renderField}
            type="text"
            placeholder="Last Name"
            label="Last Name"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="dob"*/}
          {/*  component={this.renderDateField}*/}
          {/*  type="text"*/}
          {/*  label="Date of Birth"*/}
          {/*/>*/}
          <Field
            className="form-control"
            name="dob"
            component={this.renderField}
            type="text"
            placeholder="MM/DD/YYYY"
            label="Date of Birth"
          />
          <Field
            name="genderObj"
            component={this.renderGenderSelect}
            label="Gender"
          />
          <legend></legend>
          <Field
            className="form-control"
            name="mobilePhone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Mobile Phone"
          />
          <Field
            className="form-control"
            name="homePhoneNumber"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Home Phone"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="phoneNumber"*/}
          {/*  component={this.renderField}*/}
          {/*  type="text"*/}
          {/*  placeholder="(XXX) XXX-XXXX"*/}
          {/*  label="Work Phone"*/}
          {/*/>*/}
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="phoneType"*/}
          {/*  component={this.renderPhoneTypesSelect}*/}
          {/*  label="Primary Phone Type"*/}
          {/*/>*/}
          <Field
            className="form-control"
            name="email"
            component={this.renderField}
            placeholder="Email"
            type="text"
            label="Email"
          />
          <legend></legend>
          <Field
            className="form-control"
            name="addressLine1"
            component={this.renderField}
            type="text"
            placeholder="Address 1"
            label="Address 1"
          />
          <Field
            className="form-control"
            name="addressLine2"
            component={this.renderField}
            type="text"
            placeholder="Address 2"
            label="Address 2"
          />
          <Field
            className="form-control"
            name="addressCity"
            component={this.renderField}
            placeholder="City"
            type="text"
            label="City"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="state"*/}
          {/*  component={this.renderStatesSelect}*/}
          {/*  label="State"*/}
          {/*/>*/}
          <Field
            className="form-control"
            component={this.renderSelect}
            name="stateId"
            type="text"
            label="State"
            onChange={this.onChange}
          >
            <option value="0">Select</option>
            {states1 &&
              states1.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
          <Field
            className="form-control"
            name="addressZip"
            component={this.renderField}
            type="text"
            label="Zip"
            placeholder="Zip"
            maxLength={5}
          />
          <Field
            className="form-control"
            name="addressCountry"
            component={this.renderField}
            placeholder="Country"
            type="text"
            label="Country"
          />
        </fieldset>
        
        <div className="form-actions">
          <div   className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.dob) {
    errors.dob = 'Required';
  } else if (!/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(18|19|20)\d{2}$/i.test(values.dob)) {
    errors.dob = 'Invalid DOB';
  }
  if (!values.genderObj) {
    errors.genderObj = 'Required';
  }
  if (!values.addressLine1) {
    errors.addressLine1 = 'Required';
  }
  if (!values.addressCity) {
    errors.addressCity = 'Required';
  }
  if (!values.stateId) {
    errors.stateId = 'Required';
  }
  else if (values.stateId === '0') {
    errors.stateId = 'Required';
  }
  if (!values.addressZip) {
    errors.addressZip = 'Required';
  }
  else if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(values.addressZip)) {
    errors.addressZip = 'Invalid Zip';
  }

  if (values.email) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
  }

  if (!values.mobilePhone && !values.homePhoneNumber) {
    errors.mobilePhone = 'Atleast one phone number is required.';
    errors.homePhoneNumber = 'Atleast one phone number is required.';
  }
  else if (values.mobilePhone) {
    if (!/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i.test(values.mobilePhone)) {
      errors.mobilePhone = 'Invalid phone ex. (XXX) XXX-XXXX';
    }
  }
  else if (values.homePhoneNumber) {
    if (!/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i.test(values.homePhoneNumber)) {
      errors.homePhoneNumber = 'Invalid phone ex. (XXX) XXX-XXXX';
    }
  }

  return errors;
};

PatientForm = connect(state => ({
  formValues: getFormValues('patient')(state),
  initialValues: state.patients.patient[0],
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'patient' })(PatientForm));
export default PatientForm;



// WEBPACK FOOTER //
// ./src/routes/management/components/PatientForm.js